import React, { useState } from "react";
import TimeAgo from "react-timeago";
import StaffProfileCard from "../../../Staff/partials/StaffProfileCard";
import { Staff } from "../../../../queries/staff.query";
import { useMutation } from "react-apollo";
import AuthProvider from "../../../../providers/Auth.Provider";
import LoadingSpinner from "../../../../partials/loading";
import { cleanDate } from "../../../../util/app";

const NoteList = ({ items, onEdit, onView, onConfirm, inValidate, onRemove }) => {
    // local state
    const [item, setItem] = useState();

    // get staff name and email

    const { admin, email, name } = AuthProvider.authProvider.GetAuthenticatedStaff();
    const [loginFunc, { loading }] = useMutation(Staff.MUTATION.LOGIN, {
        onCompleted: data => {
            if (data.Login) {
                onRemove(item);
            }
        }
    });

    if (items && items.length < 1)
        return (
            <div className="text-center text-pink">
                <i className="material-icons" style={{ fontSize: "4em" }}>
                    info
                </i>
                <br />
                <strong>No note has been added yet</strong>
            </div>
        );
    return (
        <div className="no-pad table-responsive">
            <LoadingSpinner loading={loading} bar={true} />
            <table className="table table-inbox table-hover table-bordered">
                <thead>
                    <tr>
                        <th style={{ width: "5%" }} className="text-center">
                            SN
                        </th>
                        <th style={{ width: "20%" }}>FORM</th>
                        <th style={{ width: "25%" }}>Summary</th>
                        <th style={{ width: "15%" }}>Category</th>
                        <th style={{ width: "15%" }}>
                            <span>Staff</span>
                        </th>
                        <th style={{ width: "20%" }} className="text-center">
                            Actions
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {items &&
                        items.map((item, index) => (
                            <tr key={index}>
                                <td className="inbox-small-cells text-center">{index + 1}</td>
                                <td className="view-message">{item.multi ? "MULTIPLE CLINICAL NOTE" : "CLINICAL NOTE"}</td>
                                <td className="view-message">
                                    {item.multi ? (
                                        <>
                                            <span>MULTIPLE CLINICAL NOTE {item.confirm.status ? <i className="fa fa-circle text-success"></i> : <i className="fa fa-circle text-danger"></i>}</span>
                                            <br />
                                            <small>
                                                <TimeAgo date={new Date(parseInt(item.notes[0].datetime))}></TimeAgo>
                                            </small>
                                        </>
                                    ) : (
                                        <>
                                            <span>
                                                {item.notes[0].summary} {item.confirm.status ? <i className="fa fa-circle text-success"></i> : <i className="fa fa-circle text-danger"></i>}
                                            </span>
                                            <br />
                                            <small>
                                                <TimeAgo date={new Date(parseInt(item.notes[0].datetime))}></TimeAgo>
                                            </small>
                                        </>
                                    )}
                                </td>
                                <td className="view-message">
                                    {item.multi ? (
                                        <span>MULTIPLE CLINICAL NOTE</span>
                                    ) : (
                                        <>
                                            {item.notes[0].category.name} <br />
                                            <small className="text-pink">{cleanDate(parseInt(item.notes[0].datetime))}</small>
                                        </>
                                    )}
                                </td>
                                <td className="view-message">
                                    <StaffProfileCard item={item.author} />
                                </td>
                                <td className="view-message text-center">
                                    <div>
                                        {!item.confirm.status && (
                                            <button onClick={() => onConfirm(item)} title="Confirm" className="mdl-button mdl-button--icon fade-in mdl-button--colored margin-right-10">
                                                <i className="material-icons">check_circle</i>
                                            </button>
                                        )}
                                        {!item.confirm.status && !item.multi && (
                                            <button onClick={() => onEdit(item)} title="Update" className="mdl-button fade-in mdl-button--icon mdl-button--colored btn-default margin-right-10">
                                                <i className="material-icons text-success">edit</i>
                                            </button>
                                        )}
                                        {item.confirm.status && item.validity.status && (
                                            <button
                                                onClick={() => inValidate(item)}
                                                title="Invalidate Note"
                                                className="mdl-button fade-in mdl-button--icon mdl-button--colored btn-default margin-right-10"
                                            >
                                                <i className="material-icons text-pink">report</i>
                                            </button>
                                        )}
                                        <button onClick={() => onView(item)} title="View" className="mdl-button mdl-button--icon mdl-button--colored btn-default">
                                            <i className="material-icons text-primary">arrow_right_alt</i>
                                        </button>
                                        {admin && (
                                            <button
                                                onClick={async () => {
                                                    setItem(item);
                                                    const pass = window.prompt("Enter password to continue!\n Name: " + name);
                                                    if (pass)
                                                        await loginFunc({
                                                            variables: {
                                                                email,
                                                                password: pass
                                                            }
                                                        });
                                                }}
                                                title="remove"
                                                className="mdl-button mdl-button--icon mdl-button--colored fade-in"
                                            >
                                                <i className="material-icons text-danger">delete</i>
                                            </button>
                                        )}
                                    </div>
                                </td>
                            </tr>
                        ))}
                </tbody>
            </table>
        </div>
    );
};

export default NoteList;
